import { render, staticRenderFns } from "./DraftPriceChangeRequest.vue?vue&type=template&id=387137d2&"
import script from "./DraftPriceChangeRequest.vue?vue&type=script&lang=js&"
export * from "./DraftPriceChangeRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports